// USA
export const locale = {
  lang: 'ar',
  data: {
    Create: 'إنشاء',
    Update: 'تحديث',
    View: 'مشاهدة',
    TRANSLATOR: {
      SELECT: 'اختار اللغة',
    },
    ACTIONS: {
      RESET: "إعادة تعيين",
      APPLY: "تطبيق",
      ADD_RETURN: 'إضافة مرتجع',
      PRINT: "طباعة"
    },
    OPEN_IN_NEW_TAP: "افتح في صفحة جديدة",
    DASHBAORD: {
      FASTLINKS: 'روابط سريعة',
    },
    DASHBOARD: {
      LOADING: 'جاري التحميل...',
      FILTERS: {
        TIME_FILTER: 'الفلتر الزمني',
        SELECT_TIME: 'اختر الفترة الزمنية',
        LAST_7_DAYS: 'آخر 7 أيام',
        LAST_MONTH: 'آخر شهر',
        LAST_YEAR: 'آخر سنة'
      },
      STATUS: {
        ACTIVE: 'نشط',
        PENDING: 'قيد الانتظار',
        INACTIVE: 'غير نشط',
        CANCELLED: 'ملغي',
        TRIAL: 'تجريبي',
        EXPIRED: 'منتهي',
        PAID: 'مدفوع',
        FAILED: 'فشل الدفع',
      },
      STATS: {
        TOTAL_TENANTS: 'إجمالي المشتركين',
        TOTAL_TENANTS_DESC: 'عدد جميع المشتركين في النظام',
        TOTAL_SUBSCRIPTIONS: 'إجمالي الاشتراكات',
        TOTAL_SUBSCRIPTIONS_DESC: 'عدد جميع الاشتراكات',
        TOTAL_PACKAGES: 'إجمالي الباقات',
        TOTAL_PACKAGES_DESC: 'عدد الباقات المتاحة',
        TOTAL_USERS: 'إجمالي المستخدمين',
        TOTAL_USERS_DESC: 'عدد جميع المستخدمين'
      },
      CHARTS: {
        SUBSCRIPTIONS_BY_STATUS: 'توزيع الاشتراكات حسب الحالة',
        SUBSCRIPTIONS_BY_PACKAGE: 'توزيع المشتركين حسب الباقات',
        SUBSCRIPTIONS_BY_PACKAGE_AND_STATUS: 'توزيع الاشتراكات حسب الباقة والحالة',
        SUBSCRIPTIONS_BY_PACKAGE_AND_STATUS_DESC: 'تفصيل عدد الاشتراكات لكل حالة داخل كل باقة',
        STATUS_OVERVIEW: 'نظرة على الحالات',
        PACKAGE_RANKING: 'ترتيب الباقات',
        PACKAGE_STATUS_INSIGHTS: 'تحليل الباقات والحالات',
        GROWTH_TREND: 'منحنى النمو',
        SUBSCRIPTIONS_GROWTH: 'نمو الاشتراكات عبر الزمن',
        SUBSCRIPTIONS_GROWTH_DESC: 'عدد الاشتراكات الجديدة خلال الفترة المحددة',
        SUBSCRIPTIONS_COUNT: 'عدد الاشتراكات',
        TOTAL: 'الإجمالي',
      },
      TABLES: {
        RECENT_SUBSCRIPTIONS: 'آخر الاشتراكات',
        RECENT_SUBSCRIPTIONS_DESC: 'آخر 10 اشتراكات في النظام',
        RECENT_TENANTS: 'المشتركين النشطين',
        RECENT_TENANTS_DESC: 'آخر 10 مشتركين نشطين',
        NO_DATA: 'لا توجد بيانات'
      },
      ERRORS: {
        ERROR: 'خطأ',
        LOAD_STATISTICS: 'حدث خطأ أثناء تحميل الإحصائيات'
      }
    },
    SHIFT_CATEGORIES: {
      GENERAL: {
        CREATE: 'إنشاء فئة وردية',
        CREATE_SHIFT_CATEGORY: 'إنشاء فئة وردية',
        SHIFT_CATEGORIES: 'فئات الورديات',
      },
      LABEL: {
        NAME: 'الاسم',
        START_TIME: 'وقت البدء',
        END_TIME: 'وقت الانتهاء',
        BRANCH: 'الفرع',
        ISACTIVE: 'الحالة',
        NAME_AR: 'الاسم بالعربية',
        NAME_EN: 'الاسم بالإنجليزية',
      },
      PLACEHOLDER: {
        NAME_AR: 'أدخل الاسم بالعربية',
        NAME_EN: 'أدخل الاسم بالإنجليزية',
      },
      VALIDATION: {
        NAME_AR: 'الاسم بالعربية مطلوب',
        NAME_EN: 'الاسم بالإنجليزية مطلوب',
        START_TIME: 'وقت البدء مطلوب',
        END_TIME: 'وقت الانتهاء مطلوب',
      }
    },
    PAYMENTS: {
      PAYMENT_ID: 'رقم الدفع',
      TENANT_NAME: 'اسم المستأجر',
      DATE: 'تاريخ الدفع',
      NOTES: 'ملاحظات',
      AMOUNT: 'المبلغ',
      METHOD: 'طريقة الدفع',
      STATUS: 'الحالة',
      CREATE: 'انشاء دفع',
      UPDATE: 'تحديث الدفع',
      TITLE: 'الدفع',
      LABEL: {
        TENANT: 'المستأجر',
        PACKAGE: 'الاشتراك',
        AMOUNT: 'المبلغ',
        METHOD: 'طريقة الدفع',
        NOTES: 'ملاحظات'
      },
      PLACEHOLDER: {
        TENANT: 'اختر المستأجر',
        PACKAGE: 'اختر الاشتراك',
        AMOUNT: 'أدخل المبلغ',
        METHOD: 'اختر طريقة الدفع',
        NOTES: 'أدخل ملاحظات (اختياري)'
      },
      VALIDATION: {
        TENANT: 'المستأجر مطلوب',
        PACKAGE: 'الاشتراك مطلوب',
        AMOUNT: 'المبلغ مطلوب',
        METHOD: 'طريقة الدفع مطلوبة',
      }
    },
    subscriptions: {
      title: 'الاشتراكات',
      create: 'إنشاء اشتراك',
      update: 'تحديث الاشتراك',
      view: 'مشاهدة الاشتراك',
      loading: 'جاري تحميل الاشتراكات...',
      details: 'تفاصيل الاشتراك',
      tenantName: 'اسم المستأجر',
      package: 'الباقة',
      subscriptionStatus: 'حالة الاشتراك',
      startDate: 'تاريخ البدء',
      endDate: 'تاريخ الانتهاء',
      billingCycle: 'دورة الفوترة',
      renewal: 'تجديد',
      isActive: 'نشط',
      extend: 'تمديد',
      EXTEND: {
        TITLE: 'تمديد الاشتراك',
        NEW_END_DATE_LABEL: 'تاريخ الانتهاء الجديد',
        PLACEHOLDER: 'اختر تاريخ انتهاء جديد',
        SUBMIT: 'تأكيد التمديد',
        CANCEL: 'إلغاء',
        CLOSE: 'إغلاق',
        VALIDATION: {
          REQUIRED: 'تاريخ الانتهاء الجديد مطلوب',
          NOT_AFTER_CURRENT: 'يجب أن يكون التاريخ بعد تاريخ الانتهاء الحالي للاشتراك',
        },
      },
      CUSTOMIZE: {
        TITLE: 'تخصيص الاشتراك',
        BUTTON: 'تخصيص الاشتراك',
        DESCRIPTION: 'عدّل حدود الميزات التالية لهذا الاشتراك. التغييرات تُطبَّق بعد الحفظ والتأكيد.',
        ENABLE_ON_CREATE: 'تخصيص ميزات الاشتراك',
        SELECT_PACKAGE_FIRST: 'اختر الباقة أولاً لعرض الميزات القابلة للتخصيص.',
        NO_FEATURES: 'لا توجد ميزات قابلة للتخصيص في هذه الباقة.',
        IS_CUSTOM_BADGE: 'اشتراك مخصص',
        VALUE_HINT: 'القيمة المسموحة من {{min}} إلى {{max}}',
        SUBMIT: 'حفظ التخصيص',
        CANCEL: 'إلغاء',
        CLOSE: 'إغلاق',
        VALIDATION: {
          REQUIRED: 'هذا الحقل مطلوب',
        },
      },
      activeToggle: 'تفعيل / تعطيل',
      activateSubscription: 'تفعيل',
      deactivateSubscription: 'تعطيل',
      zatca: 'الزكاة',
      LABEL: {
        TENANT: 'المستأجر',
        PACKAGE: 'الباقة',
        AUTO_RENEWAL: 'تجديد تلقائي',
        IS_ZATKA_ENABLED: 'مفعل الزكاة',
        PAYMENT_PERIOD: 'فترة الدفع',
        IS_ACTIVE: 'نشط'
      },
      PLACEHOLDER: {
        TENANT: 'اختر المستأجر',
        PACKAGE: 'اختر الباقة',
        AUTO_RENEWAL: 'تمكين التجديد التلقائي',
        IS_ZATKA_ENABLED: 'تمكين الزكاة',
        PAYMENT_PERIOD: 'اختر فترة الدفع',
        IS_ACTIVE: 'اختر الحالة'
      },
      VALIDATION: {
        TENANT: 'يجب اختيار المستأجر',
        PACKAGE: 'يجب اختيار الباقة',
        AUTO_RENEWAL: 'قيمة التجديد التلقائي مطلوبة',
        IS_ZATKA_ENABLED: 'حالة الالزكاة مطلوبة',
        PAYMENT_PERIOD: 'فترة الدفع مطلوبة',
        IS_ACTIVE: 'الحالة مطلوبة'
      }
    },
    "PACKAGES": {
      SELECT_MODULES: "اختر الانظمة",
      SELECT_ALL_PAGES: "تحديد جميع الصفحات",
      ENABLE_MODULE: "تفعيل النظام",
      "LABEL": {
        "NAME_EN": "اسم الباقة (إنجليزي)",
        "NAME_AR": "اسم الباقة (عربي)",
        "CODE": "كود الباقة",
        "TIER_LEVEL": "المستوى",
        "DESC_EN": "الوصف (إنجليزي)",
        "DESC_AR": "الوصف (عربي)",
        "DESC": "الوصف",
        "NAME": "اسم الباقة",
        "PRICE": "السعر الشهري",
        "YEARLY_PRICE": "السعر السنوي",
        "DISCOUNT_PERCENT": "نسبة الخصم (%)",
        "SUBSCRIPTION_TYPE": "نوع الاشتراك",
        "DURATION": "المدة (بالأيام)",
        "ISACTIVE": "مُفعّل",
        "RESOURCES": "الموارد",
        "RESOURCE_NAME": "اسم المورد",
        "RESOURCE_DESC": "وصف المورد",
        "ASSIGN": "تعيين",
        "FEATURES": "المميزات",
        "VALUE": "القيمة"
      },
      "PLACEHOLDER": {
        "NAME_EN": "أدخل اسم الباقة بالإنجليزية",
        "NAME_AR": "أدخل اسم الباقة بالعربية",
        "CODE": "أدخل كود الباقة",
        "TIER_LEVEL": "أدخل المستوى (عدد صحيح من 0 فما فوق)",
        "DESC_EN": "أدخل الوصف بالإنجليزية",
        "DESC_AR": "أدخل الوصف بالعربية",
        "PRICE": "أدخل السعر الشهري",
        "YEARLY_PRICE": "أدخل السعر السنوي",
        "DISCOUNT_PERCENT": "أدخل نسبة الخصم",
        "DURATION": "أدخل الفترة",
      },
      "VALIDATION": {
        "NAME_EN": "اسم الباقة بالإنجليزية مطلوب",
        "NAME_AR": "اسم الباقة بالعربية مطلوب",
        "CODE": "كود الباقة مطلوب",
        "TIER_LEVEL": "المستوى مطلوب ويجب أن يكون عدداً صحيحاً من 0 فما فوق",
        "DESC_EN": "الوصف بالإنجليزية مطلوب",
        "DESC_AR": "الوصف بالعربية مطلوب",
        "PRICE": "السعر الشهري مطلوب",
        "YEARLY_PRICE": "السعر السنوي مطلوب",
        "DISCOUNT_PERCENT": "نسبة الخصم يجب أن تكون رقماً صحيحاً من 0 إلى 100",
        "DURATION": "الفترة مطلوبة",
        "FEATURE_VALUE_INVALID": "أدخل رقماً صحيحاً.",
        "FEATURE_VALUE_MIN": "الحد الأدنى {{min}}.",
        "FEATURE_VALUE_MAX": "الحد الأقصى {{max}}.",
        "FEATURE_VALUES_INVALID": "تأكد من صحة قيم المميزات (الحدود المسموحة)."
      },
      "GENERAL": {
        "CREATE": "إنشاء باقة",
        "UPDATE": "تحديث الباقة",
        "LIST": "قائمة الباقات",
        "MAIN": "الباقات"
      },
      "BTN": {
        "RESET": "إعادة تعيين"
      },
      "TITLE": "باقة"
    },
    FEATURES: {
      TITLE: 'الميزات',
      SINGLE: 'ميزة',
      UPDATE: 'تحديث الميزة',
      LABEL: {
        NAME: 'الاسم',
        NAME_AR: 'الاسم (عربي)',
        NAME_EN: 'الاسم (إنجليزي)',
        DESCRIPTION: 'الوصف',
        DESCRIPTION_AR: 'الوصف (عربي)',
        DESCRIPTION_EN: 'الوصف (إنجليزي)',
        FEATURE_TYPE: 'نوع الميزة',
        CONTROL_TYPE: 'نوع التحكم',
        VALUE: 'القيمة الافتراضية',
        PRICE: 'السعر',
        IS_ACTIVE: 'نشط',
      },
      PLACEHOLDER: {
        NAME_AR: 'أدخل الاسم بالعربية',
        NAME_EN: 'أدخل الاسم بالإنجليزية',
        DESCRIPTION_AR: 'أدخل الوصف بالعربية',
        DESCRIPTION_EN: 'أدخل الوصف بالإنجليزية',
        VALUE: 'أدخل القيمة الافتراضية',
        PRICE: 'أدخل السعر',
      },
      VALIDATION: {
        NAME_AR: 'الاسم بالعربية مطلوب',
        NAME_EN: 'الاسم بالإنجليزية مطلوب',
        VALUE: 'القيمة مطلوبة',
        PRICE: 'السعر مطلوب',
        REQUIRED: 'هذا الحقل مطلوب',
        WHITESPACE: 'لا يمكن أن يكون الحقل فارغاً أو مسافات فقط',
        MAX_LENGTH: 'الحد الأقصى {{max}} حرفاً',
        PRICE_MIN: 'السعر يجب أن يكون {{min}} أو أكثر',
        PRICE_MAX: 'السعر يجب ألا يتجاوز {{max}}',
        BOOLEAN_VALUE: 'القيمة يجب أن تكون true أو false أو 0 أو 1',
        VALUE_HINT: 'القيمة المسموحة من {{min}} إلى {{max}}',
        INVALID: 'قيمة غير صالحة',
      },
      STATUS: {
        ACTIVE: 'نشط',
        INACTIVE: 'غير نشط',
      },
      BTN: {
        UPDATE: 'تحديث',
        CANCEL: 'إلغاء',
        BACK: 'رجوع',
      },
    },
    "TENANT": {
      "TITLE": "المؤسسات",
      "CREATE": "إنشاء مؤسسة",
      "UPDATE": "تعديل مؤسسة",
      "DELETE": "حذف مؤسسة",
      "VIEW": "عرض مؤسسة",
      "LOADING": "جاري تحميل المؤسسات...",
      "DETAILS": "تفاصيل المؤسسة",
      "LABEL": {
        "COMPANY_NAME": "اسم الشركة",
        "COMPANY_NAME_AR": "اسم الشركة (عربي)",
        "COMPANY_NAME_EN": "اسم الشركة (إنجليزي)",
        "EMAIL": "البريد الإلكتروني",
        "PHONE": "رقم الهاتف",
        "SUBSCRIPTION_PLAN": "خطة الاشتراك",
        "SUBSCRIPTION_STATUS": "حالة الاشتراك",
        "IS_ACTIVE": "مفعل"
      },
      "PLACEHOLDER": {
        "COMPANY_NAME_AR": "أدخل اسم الشركة (عربي)",
        "COMPANY_NAME_EN": "أدخل اسم الشركة (إنجليزي)",
        "EMAIL": "أدخل البريد الإلكتروني",
        "PHONE": "أدخل رقم الهاتف",
        "SUBSCRIPTION_PLAN": "أدخل خطة الاشتراك"
      },
      "VALIDATION": {
        "COMPANY_NAME": "اسم الشركة مطلوب",
        "COMPANY_NAME_AR": "اسم الشركة (عربي) مطلوب",
        "COMPANY_NAME_EN": "اسم الشركة (إنجليزي) مطلوب",
        "EMAIL": "البريد الإلكتروني مطلوب",
        "PHONE": "رقم الهاتف مطلوب",
        "SUBSCRIPTION_PLAN": "خطة الاشتراك مطلوبة"
      },
      "ACTIONS": "إجراءات"
    },
    FILTER: {
      LABELS: {
        EQUAL: 'يساوي',
        NOT_EQUAL: 'لا يساوي',
        LESS_THAN: 'أقل من',
        LESS_THAN_OR_EQUAL: 'أقل من أو يساوي',
        GREATER_THAN: 'أكثر من',
        GREATER_THAN_OR_EQUAL: 'أكثر من أو يساوي',
        STARTSWITH: 'يبدأ بـ',
        ENDSWITH: 'ينتهي بـ',
        CONTAINS: 'يحتوي على',
      },
      PLACEHOLDER: {
        COLUMN: "اختر العمود الذي تريده",
        VALUE: "تصفية حسب القيمة",
        OPTION: "اختر خيارًا",
        OPERATOR: "اختر المعادلة",
      },
      BTN: {
        APPLY: "تطبيق",
        RESET: 'إعادة تعيين',
      }
    },
    AccountNature: {
      DEBIT: "مدين",
      CREDIT: "دائن",
      DEBIT_CREDIT: "مدين / دائن"
    },
    // start of intermediate account
    INTERMEDIATE_ACCOUNT: {
      LABELS: {
        NAME_AR: 'الاسم (عربي)',
        NAME_EN: 'الاسم (إنجليزية)',
        ACCOUNT: 'الحساب',
        BRANCH: 'الفرع',
        SAVE: 'حفظ'
      },
      PLACEHOLDER: {
        BRANCH: 'اختر الفرع',
        ACCOUNT: 'اختر الحساب',
      },
    },
    // end of intermediate account

    AUTHS: {
      NEXT: 'التالي',
      RESET_PASSWORD: 'إعادة تعيين كلمة المرور',
      CHANGE_PASSWORD: 'تغيير كلمة المرور',
      CURRENT_PASSWORD: 'كلمة المرور الحالية',
      NEW_PASSWORD: 'كلمة المرور الجديدة',
      CONFIRM_NEW_PASSWORD: 'تأكيد كلمة المرور الجديدة',
      PASSWORDS_MUST_MATCH: 'كلمات المرور لا تتطابق',
      GO_BACK: 'الرجوع الى',
      LOGOUT: 'تسجيل الخروج',
      LOGIN: {
        WELCOME_TO: 'مرحباً بك في ',
        TABWEEB: 'يُسر',
        FULL_WELCOME: 'مرحباً بك في يُسر',
        LOGINS: 'تسجيل الدخول',
        LOG_IN: 'دخول',
        SIGN_IN: 'تسجيل الدخول',
        SIGN_SIGN_UP: 'إنشاء حساب',
        SIGN_GOOGLE: 'تسجيل الدخول باستخدام جوجل',
        FORGET_PASSWORD: 'نسيت كلمة السر',
        BACK: 'رجوع',
        SIGNUP_MESSAGE: 'ليس لديك حساب؟',
        RECOVER_PASSWORD: 'استعادة كلمة المرور',
        SEND_EMAIL_FIRST: 'لقد أرسلنا بريدًا إلكترونيًا إلى ',
        SEND_EMAIL_LAST:
          'يرجى النقر على الرابط المستلم للتحقق من بريدك الإلكتروني وإنشاء حسابك. أو أدخل الرمز هنا.',
        REGISTER: 'تسجيل',
        FOOTER_COPYRIGHT: 'جميع الحقوق محفوظة لشركة تبويب العربية لتقنية المعلومات',
        REMEMBER_PASSWORD: 'تذكّر كلمة السر',
        TWO_FACTOR_TITLE: 'التحقق بخطوتين',
        TWO_FACTOR_DESC: 'أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة لإكمال تسجيل الدخول.',
        TWO_FACTOR_VERIFYING: 'جاري التحقق… سيتم توجيهك خلال لحظات.',
        FORM: {
          PLACEHOLDER: {
            EMAIL: 'أدخل بريدك الالكتروني أو اسم المستخدم',
            PASSWORD: 'أدخل كلمة السر هنا',
          },
          LABEL: {
            EMAIL: 'أدخل بريدك الالكتروني أو اسم المستخدم',
            PASSWORD: 'أدخل كلمة السر',
            NEW_PASSWORD: 'أدخل كلمة المرور الجديدة',
          },
          VALIDATION: {
            EMAIL: 'هذا الحقل مطلوب ويجب أن يكون بريدا الكترونيا أو اسم مستخدم',
            PASSWORD:
              'كلمة السر يجب أن تكون على الأقل 8 حروف طويلة وتحتوي على الأقل حرف كبير وحرف صغير ورقم أو رمز خاص.',
            PASSWORD1:
              'كلمة المرور مطلوبة',
          },
        },
      },
    },
    INVOICES: {
      GENERAL: {
        ADD_INVOICE: 'إضافة فاتورة',
        ADD_INVOICE_SALES: 'إضافة فاتورة مبيعات',
        ADD_INVOICE_PURCHASES: 'إضافة فاتورة مشتريات',
        VIEW_INVOCES: 'عرض الفواتير',
        VIEW_RETURN_INVOCES: 'عرض الفواتير المرتجعة',
        VIEW_RETURN_INVOCE: 'عرض الفاتورة المرتجعة',
      },
      LABEL: {
        CUSTOMER: 'العميل',
        VENDOR: 'المورد',
        DESCRIPTION: 'الوصف',
        PAYMENT_METHOD: 'طريقة الدفع',
        SELECT_PRODUCTS: 'اختر المنتجات',
      },
      PLACEHOLDERS: {
        INV_DATE: 'اختر تاريخ الفاتورة',
        CUSTOMER: 'اختر عميلا',
        VENDOR: 'اختر موردا',
        PAYMENT_METHOD: 'اختر طريقة الدفع',
        DESCRIPTION: 'أضف ملاحظات هنا',
        CHOOSE_PRODUCT: 'اختر منتج',
      },
      VALIDATION: {
        INV_DATE: 'تاريخ الفاتورة مطلوب',
        CUSTOMER: 'العميل مطلوب',
        VENDOR: 'المورد مطلوب',
        PAYMENT_METHOD: 'طريقة الدفع مطلوبة',
      },
    },
    MENU: {
      NEW: 'جديد',
      ACTIONS: 'الأحداث',
      CREATE_POST: 'أضافة منشور جديد',
      PAGES: 'الصفحات',
      FEATURES: 'السمات',
      APPS: 'التطبيقات',
      DASHBOARD: 'الصفحة الرئيسية',
    },
    GENERAL: {
      SUBMIT_BUTTON: 'حفظ',
      SEARCH: 'بحث ...',
      FILTER: 'تصفية',
      IMPORT: 'استيراد',
      EXPORT: 'تصدير',
      ALL: 'الكل',
      ACTIVE: 'نشط',
      UNACTIVE: 'غير نشط',
    },
    REPORTS: {
      VALIDATION: {
        DATE_RANGE_INCOMPLETE: 'يرجى إدخال تاريخ البداية وتاريخ النهاية',
        DATE_RANGE_INVALID: 'تاريخ البداية يجب أن يكون قبل أو يساوي تاريخ النهاية',
      },
      KPI: {
        TOTAL_REVENUE: 'إجمالي الإيرادات',
        TOTAL_PAYMENTS: 'إجمالي المدفوعات',
        SUCCESSFUL_PAYMENTS: 'المدفوعات الناجحة',
        PENDING_PAYMENTS: 'المدفوعات المعلقة',
        TOTAL_SUBSCRIPTIONS: 'إجمالي الاشتراكات',
        BY_STATE: 'حسب الحالة',
        TOTAL_USERS: 'إجمالي المستخدمين',
        USERS_WITH_ROLES: 'المستخدمين ذوي الأدوار',
      },
      LABEL: {
        PAYMENT_ID: 'رقم الدفع',
        AMOUNT: 'المبلغ',
        PAYMENT_DATE: 'تاريخ الدفع',
        STATUS: 'الحالة',
        METHOD: 'طريقة الدفع',
        PACKAGE_NAME: 'اسم الباقة',
        PAYMENT_PERIOD: 'فترة الدفع',
        START_DATE: 'تاريخ البدء',
        END_DATE: 'تاريخ الانتهاء',
        PAYMENT_STATUS: 'حالة الدفع',
      },
    },
    PAGINATION: {
      DISPLAYING: 'عرض',
      OF: 'من',
      RECORDS: 'السجلات',
    },
    SIDEMENU: {
      HOME: 'الرئيسية',
      TENATNS: 'المؤسسات',
      PACKAGES: 'الباقات',
      FEATURES: 'الميزات',
      ROLES: 'الادوار',
      SUBSCRIPTIONS: 'الإشتراكات',
      SUBSCRIPTIONS_PAYMENTS: 'مدفوعات الاشتراكات',
      PAYMENTS: 'المدفوعات',
      SHIFTS: 'النوبات',
      SHIFT_CATEGORIES: 'فئات النوبات',
      VERSIONS_MANAGEMENT: 'إدارة الإصدارات',
      TWO_FACTOR_AUTH: 'التحقق بخطوتين',

      ACCOUNTING: 'محاسبة',
      ACCOUNTS: 'الحسابات',
      JOURNAL: 'قيود اليومية',
      ACCOUNT_STATEMENT: 'كشف حساب',
      ACCOUNT_TYPES: 'أنواع الحسابات',
      ACCOUNT_CATEGORIES: 'فئات الحسابات',
      JOURNAL_TYPES: 'أنواع اليوميات',
      FINANCIAL_STATEMENTS: 'القوائم المالية',

      SALES_RETURN_VIEW: 'عرض فاتورة مرتجعة',

      SALES: 'المبيعات',
      CUSTOMERS: 'العملاء',
      E_INVOICING: 'الفوترة الإلكترونية',
      SALE_INVOICING: 'فاتورة مبيعات',
      PURCHASE_INVOICING: 'فاتورة مشتريات',
      RETURN_SALES: 'مرتجع المبيعات',

      PURCHASES: 'المشتريات',
      VENDORS: 'الموردون',
      RETURN_PURCHASES: 'مرتجع المشتريات',

      STOCK: 'المخزون',
      STOCK_MOVEMENT: 'حركة المخزون',
      PRODUCTS: 'المنتجات',
      PRODUCT_CATE: 'تصنيف المنتجات',
      PRODUCT_BARCODES: 'باركود المنتجات',

      FINANCE: 'المالية',
      TAX_RETURN: 'الإقرارات الضريبية',
      BALANCE_SHEET: 'الميزانية العمومية',
      TRAIL_BALANCE: 'ميزان المراجعة',

      SALES_RETURN: 'مرتجع مبيعات',
      PURCHASES_RETURN: 'مرتجع مشتريات',

      USER: 'المستخدم',
      USERS: 'المستخدمون',
      PROFILE: 'الملف الشخصي',
      SECURITY_MONITORING: 'الأمان والمراقبة',
      LOGIN_HISTORY: 'سجل تسجيلات الدخول',
      AUDIT_TRAIL: 'سجل مسار التدقيق',

      REPORTS: 'التقارير',
      TENANT_REPORTS: 'تقارير المستأجرين',
      USER_REPORTS: 'تقارير المستخدمين',
      SUBSCRIPTION_REPORTS: 'تقارير الاشتراكات',
      REVENUE_REPORTS: 'تقارير الإيرادات',

      SETTINGS: 'الإعدادات',
      COMPANIES: 'الشركات',
      COMPANY: 'الشركة',
      STORE: 'المخازن',
      CURRENCY: 'العملة',
      UNIT: 'الوحدة',
      PRICE_LEVEL: 'مستوى الأسعار',
      TAX_CATEGORIES: 'فئات الضرائب',
      ROLE: 'الدور',
      PERMISSION_ROLE: 'صلاحيات الدور',

      VIEW_INVOCE: 'عرض الفاتورة',
      BRANCHES: "الفروع",
      INTERMEDIATE_ACCOUNTS: "الحسابات الوسطية",
    },

    TWO_FACTOR: {
      GENERAL: {
        TITLE: 'التحقق بخطوتين',
      },
      STATUS: {
        ENABLED: 'مفعّل',
        DISABLED: 'غير مفعّل',
      },
      STEP1: { SHORT: 'التفعيل' },
      STEP2: { SHORT: 'ربط التطبيق' },
      STEP3: { SHORT: 'التأكيد' },
      STAGE1: {
        TITLE: 'المرحلة 1: تفعيل أو تعطيل',
        DESC: 'تحكم في تفعيل أو تعطيل التحقق بخطوتين لحسابك.',
        STATUS: 'الحالة الحالية',
        TOGGLE: 'تفعيل التحقق بخطوتين',
      },
      STAGE2: {
        TITLE: 'المرحلة 2: ربط تطبيق المصادقة',
        DESC: 'امسح رمز QR من تطبيق المصادقة أو أدخل المفتاح يدوياً.',
        QR_PLACEHOLDER_TITLE: 'رمز QR',
        QR_PLACEHOLDER: 'سيظهر رمز QR هنا بعد ربط الـAPI',
        MANUAL_KEY: 'مفتاح الإدخال اليدوي',
        APP_NAME: 'اسم التطبيق',
        MANUAL_KEY_HINT: 'حافظ على سرية هذا المفتاح ولا تشاركه مع أي شخص.',
      },
      STAGE3: {
        TITLE: 'المرحلة 3: تأكيد الرمز',
        DESC: 'أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة لتأكيد الإعداد.',
        USE_RECOVERY_CODE: 'استخدام رمز الاسترداد',
        USE_OTP_CODE: 'استخدام رمز التطبيق',
        RECOVERY_CODE_LABEL: 'رمز الاسترداد',
      },
      STAGE4: {
        TITLE: 'المرحلة 4: رموز الاسترداد',
        DESC: 'احتفظ برموز الاسترداد في مكان آمن. استخدمها إذا فقدت الوصول لتطبيق المصادقة.',
        PLACEHOLDER_ITEM: 'سيظهر رمز الاسترداد هنا بعد ربط الـAPI',
        RECOVERY_CODE_PLACEHOLDER: 'أدخل رمز الاسترداد',
        NO_CODES_YET: 'لا توجد رموز معروضة. انقر «إنشاء رموز الاسترداد» للحصول على رموز جديدة واحفظها في مكان آمن.',
      },
      VALIDATION: {
        CODE: 'أدخل رمزاً صحيحاً مكوّناً من 6 أرقام.',
        RECOVERY_CODE: 'أدخل رمز الاسترداد.',
      },
      BTN: {
        VERIFY: 'تأكيد',
        GENERATE_CODES: 'إنشاء رموز الاسترداد',
        DOWNLOAD_CODES: 'تنزيل رموز الاسترداد',
      },
      MSG: {
        SETUP_SUCCESS: 'تم إعداد التحقق بخطوتين. أدخل الرمز من التطبيق لتفعيله.',
        ENABLE_SUCCESS: 'تم تفعيل التحقق بخطوتين.',
        DISABLE_SUCCESS: 'تم تعطيل التحقق بخطوتين.',
        GENERATE_SUCCESS: 'تم إنشاء رموز استرداد جديدة. احفظها في مكان آمن.',
        CONFIRM_DISABLE: 'هل أنت متأكد من تعطيل التحقق بخطوتين؟',
        LOGOUT_AFTER_ENABLE: 'سيتم تسجيل خروجك تلقائياً بعد تفعيل التحقق بخطوتين. سجّل الدخول مرة أخرى باستخدام الرمز من تطبيق المصادقة.',
      },
    },
    BALANCE_SHEET: {
      GENERAL: {
        MAIN: 'ميزان المراجعة',
      },
      LABEL: {
        ACCOUNT_NUMBER: "رقم الحساب",
        ACCOUNT_NAME: "اسم الحساب",
        DEBIT: "مدين",
        CREDIT: "دائن",
        TOTAL: "الإجمالي",
      }
    },
    AUTH: {
      GENERAL: {
        OR: 'أو',
        SUBMIT_BUTTON: 'حفظ',
        NO_ACCOUNT: 'ليس لديك حساب ؟',
        SIGNUP_BUTTON: 'انشاء حساب',
        FORGOT_BUTTON: 'نسيت كلمة المرور',
        BACK_BUTTON: 'رجوع',
        PRIVACY: 'خاص',
        LEGAL: 'Legal',
        CONTACT: 'اتصال',
      },
      LOGIN: {
        TITLE: 'تسجيل الدخول',
        BUTTON: 'دخول',
      },
      FORGOT: {
        TITLE: 'نسيت كلمة المرور؟',
        DESC: 'أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور الخاصة بك',
        SUCCESS: 'لقد تم إعادة تعيين حسابك بنجاح.',
      },
      REGISTER: {
        TITLE: 'انشاء حساب ',
        DESC: 'أدخل تفاصيلك لإنشاء حسابك',
        SUCCESS: 'لقد تم تسجيل حسابك بنجاح.',
      },
      INPUT: {
        EMAIL: 'الأيميل',
        FULLNAME: 'الأسم كامل',
        PASSWORD: 'كلمة المرور',
        CONFIRM_PASSWORD: 'تاكيد كلمة المرور',
        USERNAME: 'اسم المستخدم',
      },
      VALIDATION: {
        INVALID: '{{name}} غير صحيح',
        REQUIRED: '{{name}} مطلوب',
        MIN_LENGTH: '{{name}} الحد الأدنى {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      },
    },
    // ------ START ACCOUNTING -----------------------
    BINDLABEL: {
      NAME: 'nameAr',
    },
    // -------- START TRAILBALANCE ----------------
    TRAIL_BALANCE: {
      GENERAL: {
        MAIN: 'ميزان المراجعة',
      },
      LABEL: {
        ACCOUNT_NUMBER: "رقم الحساب",
        ACCOUNT_NAME: "اسم الحساب",
        PREV_DEBIT: "مدين الرصيد السابق",
        PREV_CREDIT: "دائن الرصيد السابق",
        TRANS_DEBIT: "مدين حركة الحساب",
        TRANS_CREDIT: "دائن حركة الحساب",
        FINAL_DEBIT: "مدين الرصيد النهائي",
        FINAL_CREDIT: "دائن الرصيد النهائي",
        TOTAL: "الإجمالي",
      }
    },
    // ---------------- END TRAIL BALANCE --------------
    ACCOUNTING: {
      GENERAL: {
        MAIN: 'ادارة الحسابات',
        CHARTACC: 'الدليل المحاسبي',
        DAILYJOURNAL: 'الاستاذ العام',
        ACCOUNTSTAT: 'كشف حساب بسيط',
        ACCOUNTTYPE: 'نوع الحساب',
        ACCOUNTCATE: 'تصنيف الحسابات',
        JOURNALTYPE: 'نوع قيود اليومية',
        FINANCIALSTAT: 'البيان المالي',
      },
    },
    CHARTACC: {
      GENERAL: {
        TITLE: 'الدليل المحاسبي',
      },
      LABEL: {
        ACCOUNTCODE: 'كود الحساب',
        ACCOUNTNUMBER: 'رقم الحساب',
        ACCOUNTNAME: 'اسم الحساب',
        NAME_EN: 'الاسم الاجنبي ',
        NAME_AR: 'الأسم عربي',
        ACCONUTURE: 'طبيعة الحساب',
        LEVEL: 'المستوى',
        CATETYPE: 'نوع الحساب',
        CURRENCY: 'العملة',
        CATEGORY: 'تصنيف الحسابات',
        ACTIONS: 'الأحداث',
        PARENT: 'الحساب الاب',
        ISPARENT: 'حساب أب ',
        FINANCIALSTATE: 'القوائم المالبة',
        DESCRIBE_AR: ' الوصف عربي',
        DESCRIBE_EN: 'الوصف أجنبي',
      },
      BTN: {
        NEWACCO: 'حساب جديد',
        CREATE: 'إنشاء حساب',
        UPDATE: 'تعديل حساب',
        VIEW: 'عرض الحساب',
        CANCEL: 'إلغاء',
      },
      PLACEHOLDER: {
        ACCOUNTCODE: 'أدخل كود الحساب',
        ACCOUNTNUMBER: 'أدخل رقم الحساب',
        NAME_EN: 'ادخل الاسم أجنبي',
        NAME_AR: 'ادخل الاسم عربي',
        CURRENCY: 'اختر العملة',
        DESCRIBE_AR: 'ادخل الوصف عربي',
        DESCRIBE_EN: 'ادخل الوصف اجنبي ',
        CATEGORY: 'اختر تصنيف الحساب',
        CATETYPE: 'اختر نوع الحساب',
        FINANCIALSTATE: 'ادخل القوائم المالية',
        LEVEL: 'ادخل المستوى',
        PARENT: 'ادخل الحساب الأب',
        ACCONUTURE: 'اختر طبيعة الحساب',
      },
      VALIDATION: {
        ACCOUNTCODE: 'كود الحساب مطلوب',
        ACCOUNTNUMBER: 'رقم الحساب مطلوب',
        NAME_EN: ' الاسم الاجنبي مطلوب',
        NAME_AR: 'الاسم العربي مطلوب',
        PARENT: 'الحساب الأب مطلوب',
        ACCONUTURE: 'طبيعة الحساب مطلوبة',
      },
    },
    DAILYJOURNAL: {
      GENERAL: {
        TITLE: 'الأستاذ العام',
        ADD_JOURNAL: 'أضافة قيد يومية',
        VIEW_JOURNAL: 'عرض قيد اليومية',
      },
      LABEL: {
        JOURNALTYPE: 'نوع القيد',
        JOURNALDATE: 'تاريخ القيد',
        REFNO: 'رقم المرجع',
        DESCRIBE: 'الوصف',
        NO: 'الرقم',
        ACCOUNT: 'الحساب',
        DEBIT: 'مدين',
        CREDIT: 'دائن',
        CURRENCY: 'العملة',
        EXCHANGERATE: 'معدل التحويل',
        COMMENT: 'البيان',
        JOURNALTYPE_AR: 'نوع القيد (عربي )',
        JOURNALTYPE_EN: 'نوع القيد (أجنبي )',
        ACTIONS: 'الاحداث',
      },
      BTN: {
        ADDITEM: 'اضافة قيد يومية',
        UPDATEITEM: 'تعديل قيد اليومية',
        ADDLINE: 'أضافة سطر',
        ADDJOURNAL: 'اضافة قيد جديد ',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
      },
      PLACEHOLDER: {
        JOURNALTYPE: 'اختر نوع القيد',
        ACCOUNT: 'اختر  الحساب',
        DESCRIBE: 'أدخل الوصف',
        REFNO: 'ادخل رقم المرجع',
        JOURNALDATE: 'أدخل تاريخ القيد',
        CURRENCY: 'اختر العملة',
        SEARCH: 'البحث في قيود اليومية',
      },
      VALIDATION: {
        JOURNALTYPE: 'ادخل نوع القيد',
        JOURNALDATE: 'تاريخ القيد',
        DESCRIBE: 'أدخل الوصف',
        REFNO: 'ادخل رقم المرجع',
      },
    },
    FINANCIALSTAT: {
      GENERAL: {
        TITLE: 'البيان المالي',
        ADD_FINANCIALSTAT: 'أنشاء البيان المالي',
        VIEW_FINANCIALSTAT: 'عرض البيان المالي',
      },
      LABEL: {
        NO: 'الرقم',
        NAME: 'اسم القوائم المالية',
        NAME_EN: 'الاسم الاجنبي ',
        NAME_AR: 'الأسم عربي',
        DESC: 'الوصف',
        DESC_AR: ' الوصف عربي',
        DESC_EN: ' الوصف اجنبي ',
        CODE: 'كود',
        NOTE: 'البيان',
        PARENT: 'الأب',
        FINANCIALSTATE: 'انواع البيان المالي',
        EQUATION: 'المعدل',
        ACTIONS: 'الاحداث',
      },
      BTN: {
        ADDITEM: 'اضافة بيان مالي',
        UPDATEITEM: 'تعديل البيان المالي',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
      },
      PLACEHOLDER: {
        NAME_EN: 'ادخل الاسم أجنبي',
        NAME_AR: 'ادخل الاسم عربي',
        DESC_AR: 'ادخل الوصف عربي',
        DESC_EN: 'ادخل الوصف اجنبي ',
        CODE: 'ادخل الكود',
        NOTE: ' ادخل البيان',
        PARENT: 'اختر الأب',
        FINANCIALSTATE: 'اختر نوع البيان المالي',
        EQUATION: 'اختر نوع المعادلة',
        SEARCH: 'بحث في قائمة البيان المالي',
      },
      VALIDATION: {
        NAME_EN: ' الاسم الاجنبي مطلوب',
        NAME_AR: 'الاسم العربي مطلوب',
        DESC_AR: ' الاسم العربي مطلوب',
        DESC_EN: ' الاسم الاجنبي مطلوب',
        CODE: 'الكود مطلوب',
      },
    },
    ACCOUNTSTAT: {
      GENERAL: {
        TITLE: 'كشف حساب',
        ADD_ACCOUNTSTAT: 'إضافة كشف حساب',
        VIEW_ACCOUNTSTAT: 'قائمة كشف الحساب',
        REPORT: 'تقرير كشف الحساب',
        ANALYACCOUNT: 'الحساب التحليلي ',
        SUMMERYACCOUNT: 'ملخص حساب ',
      },
      LABEL: {
        NO: 'الرقم',
        ACCOUNTID: 'رقم الحساب',
        ACCOUNNTCODE: 'كود الحساب',
        JOURNALTYPE: 'نوع المستند',
        DATE: 'تاريخ',
        DESC: 'الوصف',
        NAME: 'اسم الحساب',
        CURRENCY: 'رقم العملة',
        CURRENCYCODE: 'كود العملة',
        CURRENCYRATE: 'سعر الصرف',
        DEBIT: 'مدين',
        CREDIT: 'دائن',
        TOTALDEBIT: 'اجمالي المدين',
        TOTALCREDIT: 'اجمالي الدائن',
        TOTAL: 'الاجمالي',
        FROMDATE: 'من تاريخ ',
        TODATE: 'الى تاريخ',
        STATMENT: 'البيان',
        REPORT_TYPE: 'نوع التقرير',
      },
      BTN: {
        ADDITEM: 'اضافة صنف',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
      },
      PLACEHOLDER: {
        SEARCH: 'البحث في قائمة الحساب المبسط',
        ACCOUNTID: 'اختر الحساب ',
        REPORT_TYPE: 'اختر نوع التقرير',
      },
      VALIDATION: {},
    },
    ACCOUNTTYPE: {
      GENERAL: {
        TITLE: 'نوع الحساب',
        ADD_ACCOUNTTYPE: 'اضافة نوع الحساب',
        VIEW_ACCOUNTTYPE: 'قائمة انوأع الحسابات',
      },
      LABEL: {
        NO: 'الرقم',
        NAME_EN: 'الاسم الاجنبي ',
        NAME_AR: 'الأسم عربي',
        DESC_AR: ' الوصف عربي',
        DESC_EN: ' الوصف اجنبي ',
        ACTIONS: 'الاحداث',
      },
      BTN: {
        ADDITEM: 'اضافة نوع حساب',
        UPDATEITEM: 'تعديل نوع الحساب',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
      },
      PLACEHOLDER: {
        NAME_EN: 'ادخل الاسم أجنبي',
        NAME_AR: 'ادخل الاسم عربي',
        DESC_AR: 'ادخل الوصف عربي',
        DESC_EN: 'ادخل الوصف اجنبي ',
        SEARCH: 'بحث في قائمة انواع الحسابات',
      },
      VALIDATION: {
        NAME_EN: ' الاسم الاجنبي مطلوب',
        NAME_AR: 'الاسم العربي مطلوب',
        DESC_AR: ' الاسم العربي مطلوب',
        DESC_EN: ' الاسم الاجنبي مطلوب',
      },
    },
    ACCOUNTCATE: {
      GENERAL: {
        TITLE: 'فئات الحسابات',
        ADD_ACCOUNTCATE: 'اضافة فئة',
        VIEW_ACCOUNTCATE: 'قائمة فئات الحسابات',
      },
      LABEL: {
        NO: 'الرقم',
        NAME_EN: 'الاسم الاجنبي ',
        NAME_AR: 'الأسم عربي',
        LEVEL: 'المستوى',
        CATETYPE: 'تصنيف الحساب',
        PARENT: 'الحساب الاب',
        ACTIONS: 'الاحداث',
      },
      BTN: {
        ADDITEM: 'اضافة فئة حسابات',
        UPDATEITEM: ' تعديل بيانات الفئة',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
      },
      PLACEHOLDER: {
        NAME_EN: 'ادخل الاسم أجنبي',
        NAME_AR: 'ادخل الاسم عربي',
        CATEGORY: 'اختر تصنيف الحساب',
        LEVEL: 'ادخل المستوى',
        PARENT: 'اختر الحساب الاب',
        SEARCH: 'بحث في قائمة تصنيف الحسابات',
      },
      VALIDATION: {
        NAME_EN: ' الاسم الاجنبي مطلوب',
        NAME_AR: 'الاسم العربي مطلوب',
        LEVEL: 'مستوى الحساب ملطوب',
      },
    },
    JOURNALTYPE: {
      GENERAL: {
        TITLE: 'نوع قيود اليومية',
        ADD_JOURNALTYPE: 'إضافة نوع القيود',
        VIEW_JOURNALTYPE: 'قائمة أنواع القيود',
      },
      LABEL: {
        NO: 'الرقم',
        NAME_EN: 'الاسم الاجنبي ',
        NAME_AR: 'الأسم عربي',
        DESC_AR: ' الوصف عربي',
        DESC_EN: ' الوصف اجنبي ',
        ACTIONS: 'الاحداث',
      },
      BTN: {
        ADDITEM: 'اضافة نوع قيود',
        UPDATEITEM: 'تعديل نوع القيد',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
      },
      PLACEHOLDER: {
        NAME_EN: 'ادخل الاسم أجنبي',
        NAME_AR: 'ادخل الاسم عربي',
        DESC_AR: 'ادخل الوصف عربي',
        DESC_EN: 'ادخل الوصف اجنبي ',
        SEARCH: 'بحث في قائمة تصنيف الحسابات',
      },
      VALIDATION: {
        NAME_EN: ' الاسم الاجنبي مطلوب',
        NAME_AR: 'الاسم العربي مطلوب',
      },
    },
    TAXRETURN: {
      GENERAL: {
        TITLE: 'الأقرار الضريبي',
        TRSTATUS: 'حالة الاقرار الضريبي',
        TSTYPE: 'نوع الاقرار الضريبي',
        VALUESALES: 'ضريبة القيمة المضافة على المبيعات ',
        VALUEPARCHAS: 'ضريبة القيمة المضافة على المشتريات',
      },
      LABEL: {
        NO: 'الرقم',
        VATNUMBER: 'الرقم الضريبي',
        SALESINV: 'قيمة الفاتورة',
        SALESRINV: 'قيمة المرتجعات',
        PARCHASINV: 'فاتورة المشتريات',
        PARCHASRINV: 'فاتورة مردود المشتريات',
        NETSLAES: 'صافي القيمة',
        NETVAT: 'صافي الضريبة',
        NETPARCHAS: 'صافي المشتريات',
        TOTALSALES: 'احمالي المبيعات',
        TOTALPARCHASE: 'اجمالي المشتريات',
        CORRECTION: 'التصحيح من الفترات السابقة',
        TOTALPREVIOUS:
          'ضريبة القيمة المضافة المنقولة من الفترة (الفترات) السابقة',
        TOTALVAT: 'إجمالي ضريبة القيمة المضافة المستحقة عن الفترة الضريبية',
        TOTAL: 'أجمالي المبلغ',
        FROMDATE: 'من تاريخ ',
        TODATE: 'الى تاريخ',
      },
      BTN: {
        ADDITEM: 'اضافة صنف',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
      },

      PLACEHOLDER: {

      },
      VALIDATION: {},
    },
    // ------ END ACCOUNTING -----------------------
    // ------ START SALES -----------------------

    SALES: {
      GENERAL: {
        MAIN: 'المبيعات',
        PRODUCTS: 'المنتجات',
        PRODUCTCATE: 'تصنيف المنتجات',
        INVOICE: 'فاتورة المبيعات ',
        RETURNINVOICE: 'مردود المبيعات',
        REPORT: 'تقارير فاتورة المبيعات',
        CUSTOMERS: 'العملاء',
      },
    },
    PRICES: {
      GENERAL: {
        TITLE: 'الاسعار',
        ADD_PRICES: 'أضف الاسعار',
      },
      BTNS: {
        ADDITEM: 'أضف سعر',
      },
    },
    UNITS_OF_MEASUREMENT: {
      GENERAL: {
        TITLE: 'وحدات القياس',
      },

      LABELS: {
        UNIT: 'الوحدة',
        SIZE: "حجم الوحدة",
        PRICE: "سعر الوحدة",
        BARCODE: "الباركود",
      },
      BTNS: {
        ADDITEM: "أضف صنف جديد"
      }
    },

    BARCODE: {
      GENERAL: {
        TITLE: 'طباعة الباركود',
      },
    },
    PRODUCTS: {
      PRODUCT_TYPE: {
        Product: 'منتج',
        RawMaterial: 'مادة اولية',
        Service: 'خدمة',
        Expenses: 'مصروفات',
      },
      GENERAL: {
        TITLE: 'المنتجات',
        CREATE_PRODUCT: 'انشاء منتج',
        UPDATE_PRODUCT: 'تعديل منتج',
        VIEW_PRODUCT: 'عرض منتج',
        BARCODES: 'باركودات المنتجات',
      },
      LABEL: {
        CODE: 'الكود',
        NAME: 'اسم المنتج',
        NAME_EN: 'الاسم الاجنبي ',
        NAME_AR: 'الاسم عربي',
        PROD_TYPE: 'نوع المنتج',
        PROD_CATE: 'تصنيف المنتجات',
        TAX_CATE: 'تصنيف الضريبة',
        TAXEXCEPTION: 'سبب الإعفاء الضريبي',
        EXCISETAX: 'فئة الضريبة الانتقائية',
        OPENSTOCK: 'المخزون الافتتاحي',
        INITCOST: 'التكلفة الأولية',
        REORDER: 'حد اعادة الطلب',
        DISCOUNTRATE: 'معدل الخصم',
        DESC_AR: ' الوصف عربي',
        DESC_EN: ' الوصف اجنبي ',
        ISACTIVE: 'السماح بالبيع',
        WITHOUTQUANTITY: 'السماح بالبيع عند نفاذ الكمية',
        LESSCOST: 'السماح بالبيع بأقل من التكلفة',
        UNITS: 'الوحدات',
        UNITNAME: 'اسم الوحدة',
        SIZE: 'الحجم',
        QUNANTITY: 'الكمية',
        BARCODE: 'الباركود',
        PRICELEVEL: 'مستوى التسعيرة',
        PRICE: 'السعر',
        BRANCH: 'الفرع',
        ACTIONS: 'الاحداث',
      },
      BTN: {
        ADDITEM: 'اضافة منتج',
        ADDPRICE: 'أضف سعر',
        UPDATEITEM: 'تعديل منتج',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
      },
      PLACEHOLDER: {
        CODE: 'ادخل الكود',
        NAME_EN: 'ادخل الاسم أجنبي',
        NAME_AR: 'ادخل الاسم عربي',
        PROD_TYPE: 'اختر نوع المنتج',
        PROD_CATE: 'اختر تصنيف المنتج',
        TAX_CATE: 'اختر تصنيف الضريبة',
        TAXEXCEPTION: 'اختر سبب الاعفاء الضريبي',
        EXCISETAX: 'اختر فئة الضريبة الانتقائية',
        OPENSTOCK: 'اختر المخزن الافتتاحية',
        INITCOST: 'ادخل التكلفة الأولية',
        REORDER: 'ادخل حد اعادة الطلب',
        DISCOUNTRATE: 'ادخل معدل الخصم',
        DESC_AR: 'ادخل الوصف عربي',
        DESC_EN: 'ادخل الوصف اجنبي ',
        UNITNAME: 'اختر الوحدة',
        PRICE: 'ادخل السعر',
        PRICELEVEL: 'اختر مستوى التسعيرة',
        BRANCH: 'ادخل الفرع',
        SEARCH: 'بحث في المنتجات',
        UNITS: 'ادخل الوحدات',
      },
      VALIDATION: {
        CODE: 'الكود مطلوب',
        NAME_EN: 'الاسم الاجنبي مطلوب',
        NAME_AR: 'الاسم العربي مطلوب',
        UNITNAME: 'الوحدة مطلوبة',
        SIZE: 'الحجم مطلوب',
        PRICELEVEL: 'مستوى التعسيرة مطلوب',
        PRICE: 'السعر مطلوب',
        UNITS: 'الوحدات مطلوبة',
        TAX_CATE: 'تصنيف الضريبة مطلوب',
        INITCOST: 'التكلفة الأولية مطلوبة',
        BARCODE_PRINTING: 'يرجى اختيار الوحدة وادخل الكمية',
      },
    },
    PRODUCTCATE: {
      GENERAL: {
        TITLE: 'تصنيف المنتجات',
      },
      LABEL: {
        NO: 'الرقم',
        NAME: 'اسم الفئة',
        NAME_EN: 'الاسم الاجنبي ',
        NAME_AR: 'الاسم عربي',
        PARENT: 'حساب الأب',
        SALESACCO: 'حساب المبيعات ',
        COSTACCO: 'حساب التكلفة ',
        ISACTIVE: 'مفعل',
        ACTIONS: 'الأحداث',
      },
      BTN: {
        ADDITEM: 'اضافة فئة منتج',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
      },
      PLACEHOLDER: {
        NAME_EN: 'ادخل الاسم أجنبي',
        NAME_AR: 'ادخل الاسم عربي',
        PARENT: 'ادخل الاب',
        SALESACCO: 'اختر حساب المبيعات',
        COSTACCO: 'اختر حساب التكلفة',
        SEARCH: 'البحث في قائمة تصنيف المنتجات',
      },
      VALIDATION: {
        NAME_EN: 'الاسم الاجنبي مطلوب',
        NAME_AR: 'الاسم العربي مطلوب',
      },
    },
    CUSTOMERS: {
      GENERAL: {
        TITLE: 'العملاء',
        SINGLE: 'عميل',
        TITLE_VENDOR: 'الموردين',
        SIGNLE_VENDOR: 'مورد',
        ADDRESS_TITLE: 'تفاصيل العنوان',
        CREATE_CUSTOMER: 'انشاء عميل',
        CREATE_VENDOR: 'انشاء مورد',
      },
      LABEL: {
        NO: 'الرقم',
        ACCOUNT_NUMBER: 'رقم الحساب',
        NAME: 'الاسم',
        TAX_REGISTRATION: 'تسجيل الضريبة',
        ACTIVE_IN_SALE: 'مفعل في المبيعات',
        NAME_EN: 'الاسم الاجنبي ',
        NAME_AR: 'الاسم عربي',
        PHONE: 'رقم الهاتف',
        ACCOUNT: 'رقم الحساب',
        PARENTACCOUNT: 'الحساب الاب ',
        ACCOUNT_CATE: 'تصنيف الحساب',
        EMAIL: 'الأيميل',
        NATIONAL_NO: 'رقم الهوية',
        CURRENCY: 'العملة',
        District: 'المقاطعة',
        MAXAMOUNT: 'اقصى مبلغ للدين',
        VAT_NO: 'رقم ضريبة القيمة المضافة',
        VAT_NAME: 'ضريبة القيمة المضافة',
        COMMERCIAL_NO: 'رقم السجل التجاري',
        COMMERCIAL_NAME: 'اسم السجل التجاري',
        NOTE: 'ملاحظات',
        ISACTIVE: 'مفعل عند البيع',
        COUNTRY: 'الدولة',
        CITY: 'المدينة',
        STREET: 'الحي',
        ADD_STREET: 'عنوان اخر ',
        BUILDING: 'رقم المبنى',
        PLOTIDENT: 'Plot Identification',
        POSTALCODE: 'الرمز البريدي',
        ACTIONS: 'الاحداث',
      },
      BTN: {
        ADDITEM: 'اضافة عميل',
        ADDVENDOR: 'إضافة مورد',
        UPDATEITEM: 'تعديل عميل',
        UPDATEVENDOR: 'تعديل مورد',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
        CANCEL: 'إلغاء',
      },
      PLACEHOLDER: {
        NAME_EN: 'ادخل الاسم أجنبي',
        NAME_AR: 'ادخل الاسم عربي',
        PHONE: 'ادخل رقم الهاتف',
        ACCOUNT: 'ادخل رقم الحساب',
        PARENTACCOUNT: 'اختر الحساب الأب',
        ACCOUNT_CATE: 'اختر تصنيف الحساب',
        EMAIL: 'ادخل الايميل',
        NATIONAL_NO: 'ادخل رقم الهوية',
        CURRENCY: 'اختر العملة',
        MAXAMOUNT: 'ادخل اعلى مبلغ للدين',
        VAT_NO: ' ادخل رقم ضريبة القيمة المضافة',
        VAT_NAME: 'ادخل ضريبة القيمة المضافة',
        COMMERCIAL_NO: 'ادخل رقم السجل التجاري',
        District: 'ادخل المقاطعة',
        COMMERCIAL_NAME: 'ادخل اسم السجل التجاري',
        NOTE: 'ادخل الملاحظات',
        COUNTRY: 'اختر الدولة',
        CITY: 'ادخل اسم المدينة',
        STREET: 'ادخل عنوان السكن',
        ADD_STREET: 'اضف عنوان اضافي',
        BUILDING: 'ادخل رقم المبنى',
        PLOTIDENT: 'Enter Plot Identification',
        POSTALCODE: 'ادخل الرمز البريدي',
        SEARCH: 'البحث في قائمة العملاء',
      },
      VALIDATION: {
        NAME_EN: 'الاسم الاجنبي مطلوب',
        NAME_AR: 'الاسم العربي مطلوب',
        PARENTACCOUNT: 'رقم الحساب الأب مطلوب',
        PHONE: 'ادخل رقم هاتف صحيح',
        EMAIL: 'ادخل ايميل صحيح',
        COUNTRY: 'اختر دولة صالحة',
        NATIONAL_NO: 'ادخل رقم هوية صالح',
        COMMERCIAL_NO: 'ادخل رقم سجل تجاري صالح',
        VAT_NO: 'ادخل رقم ضريبة القيمة المضافة صالح',
      },
    },
    INVOICE: {
      GENERAL: {
        INVOICE_TITLE: 'فاتورة مبيعات',
        INVOICE_PURCHASE_TITLE: 'فاتورة مشتريات',
        INVOICE_PAYMENT_TITLE: 'دفع الفاتورة',
        PYMENT_TITLE: 'بيانات الدفع',
        PROD_TITLE: 'المنتجات',
        DESCOUNT_TITLE: 'مبلغ الخصم',
        RETURN_TITLE: 'فاتورة مرتجع',
        CREATE_RETURN_INVOCE: 'انشاء فاتورة مرتجعات',
      },
      LABEL: {
        TYPE: 'نوع الفاتورة',
        CUSTOMER: 'العميل ',
        PHONE: 'رقم العميل',
        VENDOR: 'المورد',
        DATE: 'تاريخ الفاتورة',
        DUEDATE: 'تاريخ الاستحقاق',
        STORE: 'المخزن',
        CURRENCY: 'العملة',
        PRICELEVEL: 'مستوى التسعيرة',
        PROJECT: 'المشروع',
        COSTCENTER: 'مركز التكلفة',
        SALESMAN: 'البائع',
        BRANCH: 'الفرع',
        REFERANCE: 'رقم المرجع',
        ADDBY: 'اضافة بواسطة',
        ISCOMMIT: 'ملتزم',
        GRAND_TOTAL: 'المجموع الكلي',
        PAYMENT_STATUS: 'حالة الدفع',
        DOC_TYPE: 'نوع الوثيقة',
        DESCRIPTION: 'الوصف',
        CASH: 'نقد',
        CHARGE: 'مبلغ الاعباء',
        NO: 'الرقم',
        PRODUCT: 'المنتج',
        UNITSIZE: 'حجم الوحدة',
        QTY: 'الكمية',
        RETURN_QTY: 'الكمية المرتجعة',
        PRICE: 'السعر',
        COSTAMOUNT: 'التكلفة',
        DISCONUT: 'الخصم',
        TOTALBEFOR_VAT: 'الاجمالي قبل الضريبة',
        VAT: 'نسبة الضريبة',
        VAT_VALUE: 'مبلغ الضريبة',
        TOTAL: 'الاجمالي',
        DISCONUT_AMOUNT: 'مبلغ الخصم',
        PUSHED_AMOUNT: 'المبلغ المدفوع',
        EXCHANGE: 'سعر التحويل',
      },
      BTN: {
        ADDITEM: 'اضافة صنف',
        ADDROW: 'اضافة صف',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
        MORE: 'المزيد',
        CLOSE: 'اغلاق',
        CHOOSE: 'اختر الاصناف',
        CANCEL: 'الغاء',
      },
      PLACEHOLDER: {
        TYPE: 'اختر نوع الفاتورة',
        CUSTOMER: 'اختر العميل ',
        PHONE: 'اخل رقم العميل',
        STORE: 'اختر المخزن',
        CURRENCY: 'اختر العملة',
        CHARGE: 'ادخل مبلغ الاعباء',
        PRICELEVEL: 'اختر مستوى التسعيرة',
        PROJECT: 'اختر المشروع',
        COSTCENTER: 'اختر مركز التكلفة',
        SALESMAN: 'ادخل اسم البائع',
        BRANCH: 'اختر الفرع',
        REFERANCE: 'ادخل رقم المرجع',
        ADDBY: 'اختر احد الخيارات',
        DOC_TYPE: 'اختر نوع الوثيقة',
        CASH: 'اختر نوع الدفع',
        ACCOUNT: 'اختر الحساب',
        AMOUNT: 'المبلغ',
        DESCRIPTION: 'البيان',
        DISCONUT_AMOUNT: 'ادخل مبلغ الخصم',
        PUSHED_AMOUNT: 'ادخل المبلغ المدفوع',
        EXCHANGE: 'ادخل سعر التحويل',
        PRODUCT: 'اختر المنتج',
        SEARCH: 'البحث عن فاتورة',
      },
      VALIDATION: {},
      ERROR: {
        NOQNTITY: 'لا يوجد كمية',
      }
    },
    // ------ END SALES -----------------------
    // ------ START MODULE -----------------------
    MODULES: {
      GENERAL: {
        MAIN: 'الانظمة',
        NEW: 'نظام جديد',
        LIST: 'قائمة الأنظمة',
        PAGETYPE: 'نوع الصفحة',
        MODULE_PAGE: 'صفحة الأنظمة',
        PAGE: 'الصفحات',
        CREATE: 'إنشاء نظام',
        UPDATE: 'تحديث النظام',
        CREATE_PAGE: 'إنشاء صفحة النظام',
        CREATE_PAGE_TYPE: 'إنشاء نوع صفحة',
        ACTIONS: 'اختر إجراءات الصفحة',
      },
      LABEL: {
        CODE: 'الكود',
        NAME: 'الأسم',
        DESC: 'الوصف',
        NAME_EN: 'الاسم الاجنبي ',
        NAME_AR: 'الأسم عربي',
        DESC_AR: ' الوصف عربي',
        DESC_EN: ' الوصف اجنبي ',
        DISPLYORDER: 'ترتيب العرض',
        ISACTIVE: 'مفعل',
        RESOURCE: 'اسم المصدر',
        PAGETYPE: 'نوع الصفحة',
        PARENT: 'الاب',
        URL_PATH: 'المسار',
        CLASS_NAME: 'اسم التصنيف',
        ISVISIBLE: 'هل مرئي',
        ISALL: 'هل للجميع',
        TITLE: 'العنوان',
        ACTIONS: 'الاحداث',
        MODULE_TYPE: 'لمن',
      },
      BTN: {
        RESET: 'اعادة ضبط',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
        CLOSE: 'أغلاق',
        UPDATE_BTN: 'تحديث',
        CREATE_BTN: 'أنشاء',
        NEWPAGE: 'صفحة جديدة',
        ADDNEWPAGE: 'اضافة صفحة جديدة',
      },
      PLACEHOLDER: {
        CODE: 'ادخل الكود',
        NAME_EN: 'ادخل الاسم أجنبي',
        NAME_AR: 'ادخل الاسم عربي',
        DESC_AR: 'ادخل الوصف عربي',
        DESC_EN: 'ادخل الوصف اجنبي ',
        DISPLYORDER: 'ادخل ترتيب العرض',
        PAGETYPE: 'ادخل نوع الصفحة',
        PARENT: 'ادخل الاب',
        SEARCH: 'البحث في قائمة نوع الصفحات',
        RESOURCE: 'ادخل اسم المصدر',
        URL_PATH: 'ادخل المسار',
        CLASS_NAME: 'ادخل اسم التصنيف',
        MODULE_TYPE: 'اختر لمن',
      },
      VALIDATION: {
        CODE: 'الكود مطلوب',
        NAME_EN: ' الاسم الاجنبي مطلوب',
        NAME_AR: 'الاسم العربي مطلوب',
        PAGETYPE: 'نوع الصفحة مطلوب',
        MODULE_TYPE: 'لمن مطلوب',
      },
      MODULE_TYPE: {
        FOR_ROOT_TENANT: 'للسوبر ادمن',
        FOR_OTHER: 'للـ ERP',
        FOR_ALL: 'للجميع',
      },
    },

    // ------ END MODULE -----------------------
    // TODO: Purchases - Stock - Assets - Manufacturing - Quality - Projects - HR - Support - CRM
    // ------ START USERS -----------------------
    USERS: {
      GENERAL: {
        TITLE: 'المستخدمين',
        PROFILE: 'ملف المستخدم',
        DETAILS: 'التفاصيل',
        ADD_USER: 'اضافة مستخدم',
      },
      LABEL: {
        FRISTNAME: 'الأسم الأول',
        FIRST_NAME: 'الاسم الأول',
        LASTNAME: 'الاسم الاخير',
        LAST_NAME: 'اسم العائلة',
        FULLNAME: 'الاسم كامل',
        PHONE: 'رقم الهاتف',
        USERNAME: 'اسم المستخدم',
        USER_NAME: 'اسم المستخدم',
        EMAIL: 'البريد الإلكتروني',
        ROLES: 'الأدوار',
        ISACTIVE: 'نشط',
        IS_ACTIVE: 'نشط',
        ACTIONS: 'الاحداث',
        COMPANY: 'اسم الشركة',
        PASSWORD: 'كلمة المرور',
        CONFIRM_PASSWORD: 'تأكيد كلمة المرور',
        LAST_LOGIN: 'آخر تسجيل دخول',
      },
      BTN: {
        SAVE: 'حفظ',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
      },
      PLACEHOLDER: {
        FRISTNAME: 'ادخل الاسم الاول',
        LASTNAME: 'ادخل الاسم الاخير',
        PHONE: 'ادخل رقم الهاتف',
        USERNAME: 'ادخل اسم المستخدم',
        EMAIL: 'ادخل الايميل',
        SEARCH: 'بحث في قائمة المستخدمين',
        ROLES: 'اختر الصلاحيات',
        COMPANY: 'ادخل اسم الشركة',
        PASSWORD: 'ادخل كلمة المرور',
        CONFIRM_PASSWORD: 'أدخل كلمة المرور مرة أخرى',
      },
      VALIDATION: {
        FRISTNAME: 'الاسم الاول مطلوب',
        LASTNAME: 'الاسم الاخير مطلوب',
        PHONE: 'رقم الهاتف مطلوب',
        USERNAME: 'اسم المستخدم مطلوب',
        EMAIL: 'الايميل مطلوب',
        ROLES: 'الصلاحيات مطلوبة',
        COMPANYNAME: 'اسم الشركة مطلوب',
        PASSWORD:
          'كلمة المرور يجب أن تكون على الأقل 8 أحرف وتحتوي على حرف كبير واحد على الأقل، وحرف صغير واحد، ورقم أو رمز خاص واحد.',
        CONFIRM_PASSWORD: 'يجب أن تتطابق كلمات المرور',
      },
    },
    // ------ END USERS -----------------------
    // ------ START LOGIN_HISTORY -----------------------
    LOGIN_HISTORY: {
      GENERAL: {
        TITLE: 'سجل تسجيلات الدخول',
      },
      LABEL: {
        FULLNAME: 'الاسم الكامل',
        USERNAME: 'اسم المستخدم',
        EMAIL: 'البريد الإلكتروني',
        PHONE: 'رقم الهاتف',
        IS_ACTIVE: 'مفعل',
        LAST_LOGIN: 'آخر تسجيل دخول',
        LOGIN_PROVIDER: 'مزود تسجيل الدخول',
        STATUS: 'الحالة',
        FAILURE_REASON: 'سبب الفشل',
      },
      STATUS: {
        SUCCESS: 'نجح',
        FAILED: 'فشل',
        ACTIVE: 'مفعل',
        INACTIVE: 'غير مفعل',
      },
    },
    // ------ END LOGIN_HISTORY -----------------------
    // ------ START AUDIT_TRAIL -----------------------
    AUDIT_TRAIL: {
      GENERAL: {
        TITLE: 'سجل مسار التدقيق',
      },
      LABEL: {
        ID: 'المعرف',
        TYPE: 'النوع',
        TABLE_NAME: 'اسم الجدول',
        DATE_TIME: 'التاريخ والوقت',
        USER_ID: 'معرف المستخدم',
        USER_NAME: 'اسم المستخدم',
        EMAIL: 'البريد الإلكتروني',
        AFFECTED_COLUMNS: 'الأعمدة المتأثرة',
        PRIMARY_KEY: 'المفتاح الأساسي',
        COLUMNS: 'أعمدة',
        ACTIONS: 'الإجراءات',
      },
      TYPE: {
        CREATE: 'إنشاء',
        UPDATE: 'تحديث',
        DELETE: 'حذف',
      },
      MODAL: {
        TITLE: 'تفاصيل سجل التدقيق',
        BASIC_INFORMATION: 'المعلومات الأساسية',
        OLD_VALUES: 'القيم القديمة',
        NEW_VALUES: 'القيم الجديدة',
      },
      BTN: {
        VIEW_DETAILS: 'عرض التفاصيل',
        CLOSE: 'إغلاق',
      },
    },
    // ------ END AUDIT_TRAIL -----------------------
    "ROLES": {
      "GENERAL": {
        "CREATE": "إنشاء دور",
        "UPDATE": "تحديث الدور",
        "LIST": "قائمة الأدوار",
        "MAIN": "الأدوار",
        "SELECT_PERMISSIONS": "اختر الصلاحيات",
      },
      "CREATE": "إنشاء دور",
      "TITLE": "دور",
      "LABEL": {
        "NAME": "اسم الدور",
        "DESCRIPTION": "وصف الدور",
        "NAME_AR": "اسم الدور (عربي)",
        "NAME_EN": "اسم الدور (إنجليزي)",
        "PERMISSIONS": "الصلاحيات",
        "DESC": "الوصف",
      },
      "PLACEHOLDER": {
        "NAME_AR": "أدخل اسم الدور بالعربية",
        "NAME_EN": "أدخل اسم الدور بالإنجليزية",
        "NAME": "أدخل اسم الدور",
        "DESC": 'أدخل وصفا',
      },
      "VALIDATION": {
        "NAME_AR": "اسم الدور بالعربية مطلوب",
        "NAME_EN": "اسم الدور بالإنجليزية مطلوب",
        "NAME": "اسم الدور مطلوب",
        "DESC": "وصف الدور مطلوب",
      },
      "BTN": {
        "RESET": "إعادة تعيين"
      }
    },
    // ------ START SETTINGS -----------------------
    SETTINGS: {
      GENERAL: {
        MAIN: 'الأعدادات',
        CURRENCIES: 'العملات',
        COMPANIES: 'الشركات',
        STORES: 'المخازن',
        UNITS: 'الوحدات',
        PRICELEVEL: 'مستوى التسعيرة',
        TAXCATE: 'تصنيف الضريبة',
        ROLE: 'الصلاحيات',
        PERMISSION: 'منح الصلاحيات',
      },
    },
    // ------ END SETTINGS -----------------------
    // ------ START CURRENCIES -----------------------
    CURRENCIES: {
      GENERAL: {
        TITLE: 'العملة',
      },
      LABEL: {
        NAME_EN: 'الاسم الاجنبي ',
        NAME_AR: 'الاسم عربي',
        DESC_AR: ' الوصف عربي',
        DESC_EN: ' الوصف اجنبي ',
        EXCHANGERATE: 'سعر التحويل',
        SYMBOL: 'الاختصار',
        ISOCURRENCY: 'رمز العملة',
        PERCISION: 'الدقة',
        ISDEFAULT: 'افتراضي',
        ACTIONS: 'الاحداث',
      },
      BTN: {
        CREATE: "إنشاء عمله",
        UPDATE: "تعديل العمله",
        SAVE: 'حفظ',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
      },
      PLACEHOLDER: {
        NAME_EN: 'ادخل الاسم أجنبي',
        NAME_AR: 'ادخل الاسم عربي',
        DESC_AR: 'ادخل الوصف عربي',
        DESC_EN: 'ادخل الوصف اجنبي ',
        EXCHANGERATE: 'ادخل سعر التحويل',
        SYMBOL: 'ادخل الاختصار',
        ISOCURRENCY: 'ادخل الاختصار',
        PERCISION: 'ادخل الدقة',
        SEARCH: 'بحث في قائمة العملات',
      },
      VALIDATION: {
        NAME_EN: ' الاسم الاجنبي مطلوب',
        NAME_AR: 'الاسم العربي مطلوب',
        EXCHANGERATE: 'سعر التحويل مطلوب',
        SYMBOL: 'اختصار العملة مطلوب',
        ISOCURRENCY: 'مطلوب رمز العملة ',
        PERCISION: 'الدقة مطلوبة.',
      },
    },
    // ------ END CURRENCIES -----------------------
    BRANCHES: {
      LABEL: {
        NAME_AR: "الاسم (عربي)",
        NAME_EN: "الاسم (إنجليزي)",
        PARENT: "الفرع الأب",
        COUNTRY_CODE: "رمز الدولة",
        CURRENCY: "العملة",
        TAX_ACCOUNT: "حساب الضرائب",
        PHONE: "رقم الهاتف",
        EMAIL: "البريد الإلكتروني",
        VAT_REGISTRATION_NUMBER: "رقم تسجيل ضريبة القيمة المضافة",
        VAT_REGISTRATION_NAME: "اسم تسجيل ضريبة القيمة المضافة",
        COMMERCIAL_REGISTRATION_NUMBER: "رقم السجل التجاري",
        COMMERCIAL_REGISTRATION_NAME: "اسم السجل التجاري",
        REGION_NAME: "المنطقة / المحافظة",
        CITY_NAME: "المدينة",
        STREET_NAME: "اسم الشارع",
        ADDITIONAL_STREET_NAME: "اسم الشارع الإضافي",
        CITY_SUBDIVISION_NAME: "تجزئة المدينة",
        POSTAL_CODE: "الرمز البريدي",
        BUILDING_NUMBER: "رقم المبنى",
        NOTE: "ملاحظة",
        PHOTO: "الصورة",
        DROP_IMAGE: "أسقط الصورة هنا",
        IMAGE_COUNT: "مسموح بصورة واحدة فقط",
        REPORT_HEADER_IMAGE: "صورة ترويسة التقرير",
        REPORT_FOOTER_IMAGE: "صورة تذييل التقرير"
      },
      PLACEHOLDER: {
        NAME_AR: "أدخل الاسم بالعربية",
        NAME_EN: "أدخل الاسم بالإنجليزية",
        PARENT: "أدخل الفرع الأب",
        COUNTRY_CODE: "اختر رمز الدولة",
        CURRENCY: "اختر العملة",
        TAX_ACCOUNT: "أدخل رقم حساب الضرائب",
        PHONE: "أدخل رقم الهاتف",
        EMAIL: "أدخل البريد الإلكتروني",
        VAT_REGISTRATION_NUMBER: "أدخل رقم تسجيل ضريبة القيمة المضافة",
        VAT_REGISTRATION_NAME: "أدخل اسم تسجيل ضريبة القيمة المضافة",
        COMMERCIAL_REGISTRATION_NUMBER: "أدخل رقم السجل التجاري",
        COMMERCIAL_REGISTRATION_NAME: "أدخل اسم السجل التجاري",
        REGION_NAME: "أدخل المنطقة / المحافظة",
        CITY_NAME: "أدخل اسم المدينة",
        STREET_NAME: "أدخل اسم الشارع",
        ADDITIONAL_STREET_NAME: "أدخل اسم الشارع الإضافي",
        CITY_SUBDIVISION_NAME: "أدخل تجزئة المدينة",
        POSTAL_CODE: "أدخل الرمز البريدي",
        BUILDING_NUMBER: "أدخل رقم المبنى",
        NOTE: "أدخل ملاحظة"
      },
      VALIDATION: {
        NAME_AR: "الاسم بالعربية مطلوب ويجب ألا يتجاوز 100 حرف",
        NAME_EN: "يجب ألا يتجاوز الاسم بالإنجليزية 100 حرف",
        COUNTRY_CODE: "رمز الدولة غير صالح",
        CURRENCY: "اختيار العملة غير صالح",
        PHONE: "يجب أن يكون رقم الهاتف بين 10 و 14 حرف",
        EMAIL: "البريد الإلكتروني غير صالح"
      },
      BTN: {
        CREATE: "إنشاء فرع",
        UPDATE: "تحديث الفرع",
        RESET: "إعادة تعيين"
      },
      GENERAL: {
        TITLE: "تفاصيل الفرع",
        VIEW_BRANCHES: "عرض الفروع"
      }
    },
    // ------ START COMPANIES -----------------------
    COMPANIES: {
      GENERAL: {
        TITLE: 'الشركة',
        LIST: 'قائمة الشركات',
      },
      LABEL: {
        NAME_EN: 'الاسم الاجنبي ',
        NAME_AR: 'الاسم عربي',
        COUNTRY_CODE: 'الدولة',
        CURRENCY: 'العملة',
        NOTE: 'ملاحظات',
        PHOTO: 'الصورة',
        DROP_IMAGE: 'اسحب الصورة الى هنا او قم بالضغط هنا',
        IMAGE_COUNT: 'الرفع صورة واحده فقط',
      },
      BTN: {
        CREATE: 'إنشاء شركة',
        UPDATE: 'تحديث الشركة',
        SAVE: 'حفظ',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
      },
      PLACEHOLDER: {
        NAME_EN: 'ادخل الاسم أجنبي',
        NAME_AR: 'ادخل الاسم عربي',
        COUNTRY_CODE: 'اختر الدولة',
        CURRENCY: 'اختر العملة',
        NOTE: 'ادخل ملاحظاتك',
        SEARCH: 'بحث في قائمة الشركات',
      },
      VALIDATION: {
        NAME_AR: 'الاسم العربي مطلوب',
      },
    },
    // ------ END COMPANIES -----------------------
    // ------ START COMPANIES -----------------------
    STORE: {
      GENERAL: {
        TITLE: 'المخازن',
        ADD_STORE: 'إضافة مخزن جديد',
        VIEW_STORES: 'قائمة المخازن'
      },
      LABEL: {
        NAME: 'اسم المخزن',
        NAME_EN: 'الاسم الاجنبي ',
        NAME_AR: 'الاسم عربي',
        PARENT: 'الحساب الاب',
        SALES_ACCOUNT: 'حساب المبيعات',
        COST_ACCOUNT: 'حساب التكلفة',
        STORE_ACCOUNT: 'حساب المخزن',
        DISCOUNT_ACCOUNT: 'حساب الخصم',
        TAX_ACCOUNT: 'حساب الضريبة',
        NOTE: 'ملاحظات',
      },
      PLACEHOLDER: {
        NAME_EN: 'ادخل الاسم أجنبي',
        NAME_AR: 'ادخل الاسم عربي',
        PARENT: 'ادخل الحساب الاب',
        SALES_ACCOUNT: 'ادخل حساب المبيعات',
        COST_ACCOUNT: 'ادخل حساب التكلفة',
        STORE_ACCOUNT: 'ادخل حساب المخزن',
        DISCOUNT_ACCOUNT: 'ادخل حساب الخصم',
        TAX_ACCOUNT: 'ادخل حساب الضريبة',
        NOTE: 'ادخل ملاحظاتك',
        SEARCH: 'بحث في قائمة المخازن',
      },
      VALIDATION: {
        NAME_AR: 'الاسم العربي مطلوب',
      },
      BTN: {
        SAVE: 'حفظ',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        ADDITEM: 'اضافة مخزن',
        UPDATEITEM: 'تعديل بيانات المخزون',
        FILTER: 'فلتر',
      },
    },
    // ------ END COMPANIES -----------------------

    // ------ START UNITS -----------------------
    UNITS: {
      GENERAL: {
        TITLE: 'الوحدات',
      },
      LABEL: {
        ADDITEM: 'إضافة وحده',
        NAME_EN: 'الاسم الاجنبي ',
        NAME_AR: 'الاسم عربي',
        DEFAULTSIZE: 'الحجم الافتراضي',
        ACTIONS: 'الاحداث',
        CODE: 'الوحده',
        NAME: 'الاسم',
        NO: 'الرقم',
      },
      BTN: {
        ADDITEM: 'إضافة وحده',
        UPDATEITEM: 'تعديل وحده',
        SAVE: 'حفظ',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
      },
      PLACEHOLDER: {
        NAME_EN: 'ادخل الاسم أجنبي',
        NAME_AR: 'ادخل الاسم عربي',
        DEFAULTSIZE: 'ادخل الحجم الافتراضي',
        SEARCH: 'بحث في قائمة الوحدات',
        CODE: 'ادخل الوحده مثلاً كجم او سم .. الخ',
      },
      VALIDATION: {
        NAME_EN: ' الاسم الاجنبي مطلوب',
        NAME_AR: 'الاسم العربي مطلوب',
        DEFAULTSIZE: 'حجم الوحدة مطلوب',
        CODE: 'الوحده مطلوبة',
      },
    },
    // ------ END UNITS -----------------------
    // ------ START TAXCATE -----------------------
    TAXCATE: {
      GENERAL: {
        TITLE: 'تصنيف الضريبة',
        TAXEXCEPTION: 'سبب الاستثناء الضريب',
      },
      LABEL: {
        CODE: 'الكود',
        TAXRATE: 'معدل الضريبة',
        DESC_AR: ' الوصف عربي',
        DESC_EN: ' الوصف اجنبي ',
        NO: 'الرقم',
        TAXCATE: 'تصنيف الضريبة',
        EXCEPTION_REASON: 'سبب الاستثناء الضريبي',
        EXCISE: 'فئة الضريبة الاستهلاكية',
      },
      BTN: {
        ADDROW: 'اضافة صف',
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
      },
      PLACEHOLDER: {
        TAXRATE: 'ادخل معدل الضريبة',
        DESC_AR: 'ادخل الوصف عربي',
        DESC_EN: 'ادخل الوصف اجنبي ',
        SEARCH: 'البحث في قائمة تصنيف الضريبة',
        TAXCATE: 'اختر تصنيف الضريبة',
      },
      VALIDATION: {
        CODE: 'كود الضريبة مطلوب',
        TAXRATE: 'معدل الضريبة مطلوب',
        DESC_EN: ' الوصف اجنبي مطلوب ',
        DESC_AR: 'الوصف بالعربي مطلوب',
      },
    },
    // ------ END TAXCATE -----------------------
    PRICELEVEL: {
      GENERAL: {
        TITLE: 'مستوى التسعيرة',
      },
      LABEL: {
        NAME_EN: 'الاسم الاجنبي ',
        NAME_AR: 'الاسم عربي',
        STARTDATE: 'تاريخ البدء ',
        EXPIRYDATE: 'تاريخ الانتهاء',
        BASEDON: 'Based On',
        PRICETYPE: 'نوع التسعيرة',
        DEFAULT: 'السعر الافتراضي',
        MIN: 'ادنى سعر',
        MAX: 'اعلى سعر',
        WHOLESALE: 'سعر الجملة',
        DELIVERY: ' سعر التسليم',
        INLINESTORE: 'سعر المتجر عبر النت',
        DESEDONDATE: 'يعتمد على التاريخ',
        WEEKTYINTERVAL: 'فترة اسبوعية',
        MONTHLYINTERVAL: 'فترة شهرية',
        YEARLYINTERVAL: 'فترة سنوية',
        BASEDONRATE: 'Based On Rate',
        ISACTIVE: 'مفعل',
      },
      BTN: {
        RESET: 'اعادة تعيين',
        SEARCH: 'بحث',
        FILTER: 'فلتر',
      },
      PLACEHOLDER: {
        NAME_EN: 'ادخل الاسم أجنبي',
        NAME_AR: 'ادخل الاسم عربي',
        SEARCH: 'البحث في قائمة مستوى التسعيرة',
      },
      VALIDATION: {
        NAME_EN: ' الاسم الاجنبي مطلوب',
        NAME_AR: 'الاسم العربي مطلوب',
      },
    },
    // ------ END PRICELEVEL -----------------------
    // ------ START VERSIONS -----------------------
    VERSIONS: {
      GENERAL: {
        MAIN: 'إدارة الإصدارات',
        CREATE: 'إنشاء إصدار',
        UPDATE: 'تحديث إصدار',
        VIEW: 'عرض إصدار',
        LIST: 'الإصدارات',
        ADD_NEW_VERSION: 'إضافة إصدار جديد',
        VERSIONS: 'الإصدارات',
        FEATURES: 'الميزات',
        NO_VERSIONS: 'لا توجد إصدارات',
        ALL: 'الكل',
        ACTIVE: 'نشط',
        NOT_ACTIVE: 'غير نشط',
      },
      LABEL: {
        VERSION_NUMBER: 'رقم الإصدار',
        TAG: 'العلامة',
        NAME_AR: 'الاسم (عربي)',
        NAME_EN: 'الاسم (إنجليزي)',
        DESCRIPTION_AR: 'الوصف (عربي)',
        DESCRIPTION_EN: 'الوصف (إنجليزي)',
        RELEASE_DATE: 'تاريخ الإصدار',
        VERSION_TYPE: 'نوع الإصدار',
        STATUS: 'الحالة',
        PLATFORM_TYPE: 'المنصات المدعومة',
        IS_ACTIVE: 'مفعل',
        RELEASE_NOTES_AR: 'ملاحظات الإصدار (عربي)',
        RELEASE_NOTES_EN: 'ملاحظات الإصدار (إنجليزي)',
        FEATURES: 'الميزات المتضمنة',
        FEATURE_NAME_AR: 'اسم الميزة (عربي)',
        FEATURE_NAME_EN: 'اسم الميزة (إنجليزي)',
        FEATURE_DESCRIPTION_AR: 'وصف الميزة (عربي)',
        FEATURE_DESCRIPTION_EN: 'وصف الميزة (إنجليزي)',
        FEATURE_STATUS: 'حالة الميزة',
        FEATURE_CATEGORY: 'فئة الميزة',
        FEATURE_PLATFORM: 'منصة الميزة',
      },
      PLACEHOLDER: {
        VERSION_NUMBER: 'أدخل رقم الإصدار',
        TAG: 'أدخل العلامة',
        NAME_AR: 'أدخل الاسم (عربي)',
        NAME_EN: 'أدخل الاسم (إنجليزي)',
        DESCRIPTION_AR: 'أدخل الوصف (عربي)',
        DESCRIPTION_EN: 'أدخل الوصف (إنجليزي)',
        RELEASE_DATE: 'اختر تاريخ الإصدار',
        VERSION_TYPE: 'اختر نوع الإصدار',
        STATUS: 'اختر الحالة',
        PLATFORM_TYPE: 'اختر نوع المنصة',
        RELEASE_NOTES_AR: 'أدخل ملاحظات الإصدار (عربي)',
        RELEASE_NOTES_EN: 'أدخل ملاحظات الإصدار (إنجليزي)',
        FEATURE_NAME_AR: 'أدخل اسم الميزة (عربي)',
        FEATURE_NAME_EN: 'أدخل اسم الميزة (إنجليزي)',
        FEATURE_DESCRIPTION_AR: 'أدخل وصف الميزة (عربي)',
        FEATURE_DESCRIPTION_EN: 'أدخل وصف الميزة (إنجليزي)',
        FEATURE_STATUS: 'اختر حالة الميزة',
        FEATURE_CATEGORY: 'اختر فئة الميزة',
        FEATURE_PLATFORM: 'اختر منصة الميزة',
      },
      VALIDATION: {
        VERSION_NUMBER: 'رقم الإصدار مطلوب',
        TAG: 'العلامة مطلوبة',
        NAME_AR: 'الاسم (عربي) مطلوب',
        NAME_EN: 'الاسم (إنجليزي) مطلوب',
        RELEASE_DATE: 'تاريخ الإصدار مطلوب',
        VERSION_TYPE: 'نوع الإصدار مطلوب',
        STATUS: 'الحالة مطلوبة',
        PLATFORM_TYPE: 'نوع المنصة مطلوب',
        FEATURE_NAME_AR: 'اسم الميزة (عربي) مطلوب',
        FEATURE_NAME_EN: 'اسم الميزة (إنجليزي) مطلوب',
        FEATURE_STATUS: 'حالة الميزة مطلوبة',
        FEATURE_CATEGORY: 'فئة الميزة مطلوبة',
        FEATURE_PLATFORM: 'منصة الميزة مطلوبة',
      },
      BTN: {
        ADD_VERSION: 'إضافة إصدار',
        CREATE: 'إنشاء',
        UPDATE: 'تحديث',
        RESET: 'إعادة تعيين',
        CANCEL: 'إلغاء',
        VIEW_DETAILS: 'عرض التفاصيل',
        EDIT: 'تعديل',
        ADD_FEATURE: 'إضافة ميزة',
        DELETE_FEATURE: 'حذف ميزة',
      },
      STATUS: {
        COMPLETED: 'مكتمل',
        IN_PROGRESS: 'قيد التنفيذ',
        PLANNED: 'مخطط',
        DRAFT: 'مسودة',
        IN_REVIEW: 'قيد المراجعة',
        APPROVED: 'معتمد',
        RELEASED: 'منشور',
        ARCHIVED: 'مؤرشف',
      },
      VERSION_TYPE: {
        MAJOR: 'رئيسي',
        MINOR: 'ثانوي',
        PATCH: 'تصحيح',
        HOTFIX: 'إصلاح عاجل',
      },
      PLATFORM_TYPE: {
        WEB: 'ويب',
        MOBILE: 'موبايل',
        DESKTOP: 'سطح المكتب',
        API: 'واجهة برمجة التطبيقات',
        ALL: 'الكل',
        WEB_MOBILE: 'ويب، موبايل',
        WEB_MOBILE_DESKTOP: 'ويب، موبايل، سطح المكتب',
      },
      FEATURE_STATUS: {
        NEW: 'جديد',
        ENHANCED: 'محسّن',
        FIXED: 'مُصلح',
        DEPRECATED: 'مهجور',
      },
      FEATURE_CATEGORY: {
        NEW_FEATURE: 'ميزة جديدة',
        BUG_FIX: 'إصلاح خطأ',
        ENHANCEMENT: 'تحسين',
        SECURITY: 'أمان',
        PERFORMANCE: 'أداء',
        DOCUMENTATION: 'توثيق',
      },
      MODAL: {
        TITLE: 'تفاصيل الإصدار',
        DESCRIPTION: 'الوصف',
        BASIC_INFORMATION: 'المعلومات الأساسية',
        INCLUDED_FEATURES: 'الميزات المتضمنة',
      },
    },
    // ------ END VERSIONS -----------------------
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted',
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created',
        },
      },
    },
  },
};
